var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCflLogoSingleBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 169 164",
    style: {
      enableBackground: "new 0 0 169 164"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M129.1,64.7c4.4,7.9,6.4,17.1,5.3,26.7c-1.2,10.3-5.9,19.4-12.8,26.3l19.3,1.2l-1.4,20.3c12.4-11.4,20.9-26.9,22.9-44.7 c1.9-16.5-2-32.4-10.1-45.7l-19.7-3.5L129.1,64.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.9,37.8l1.9,3.3l0,0c1.7,0,3.5,0.1,5.3,0.3c12,1.4,22.4,7.2,29.7,15.6l3.6-19.3l19.8,3.5 c-11.8-14.8-29.4-25.1-49.8-27.4c-8.2-0.9-16.2-0.5-23.9,1.1L86.9,37.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.5,131.1c-25.2-2.8-43.3-25.3-40.4-50c0.1-0.5,0.2-1,0.3-1.5H24.9H21L19,76.2l-2.9-4.9c-0.4,2.1-0.8,4.3-1.1,6.5 c-4.7,39.9,24.6,76.2,65.2,80.8c19.3,2.2,37.6-3.2,52.2-13.6l1.3-19.9l-19.6-1.3C105.5,129.5,94.7,132.3,83.5,131.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "81,41.1 62.3,72.9 24.9,72.9 6.1,41.1 24.9,9.2 62.3,9.2 66.3,16  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCflLogoSingleBlack);
export default __webpack_public_path__ + "static/media/CFL_logo_Single_black.134718630f8fd632d3761dd93822c46f.svg";
export { ForwardRef as ReactComponent };